/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom";

import ScrollToTop from "./components/views/ScrollToTop";
import "./stylesheet/App.scss";
import "./stylesheet/_fonts.scss";
import "./stylesheet/_grid.scss";
import NavBar from "./components/navbar/NavBar";
import Footer from "./components/footer/Footer";
import ArticleInner from "./pages/cafe/ArticleInner";
import HubPage from "./pages/hub/HubPage";
import CafePage from "./pages/cafe/CafePage";
import CafeCataloguePage from "./pages/cafe/CafeCataloguePage";
import NewsCataloguePage from "./pages/cafe/NewsCataloguePage";
import NewsInner from "./pages/cafe/NewsInner";
import NoMatch from "./pages/404/NoMatch";
import AcademyPage from "./pages/academy/AcademyPage";
import PeoplePage from "./pages/people/PeoplePage";
import AcademyCataloguePage from "./pages/academy/AcademyCataloguePage";
import { setGlobalLanguage } from "./redux/reducers/language";
import { useDispatch } from "react-redux";
import CourseInner from "./pages/academy/CourseInner";
import cookies from "js-cookie";
import i18n from "./api/i18n";
import AboutZeFiPage from "./pages/about/AboutZeFiPage";
// import { setLang, getLang } from "./redux/reducers/lang";

function App() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [langCheck, setCheck] = useState(false);

  //const { pathname } = window.location;
  const supportedLanguages = ["en", "ar"];

  const languages = [
    { code: "en", name: "En", dir: "ltr" },
    { code: "ar", name: "Ar", dir: "rtl" },
  ];
  dispatch(setGlobalLanguage(languages));

  const handleEvent = () => {
    history.go(0);
  };

  //listerning to the browser back button click to refresh the page
  window.addEventListener("popstate", handleEvent);

  //قريبا

  useEffect(() => {
    const langCookie = cookies.get("i18next") || "en";
    setCheck(false);

    //Check if url has language param
    const url = location.pathname.split("/");

    const langCode = url.filter((word) => supportedLanguages.includes(word));

    if (langCode.length === 0) {
      // if current pathname doesn't have language code add it from the cookie or default to 'en'
      setCheck(false);
      if (url[1] === "") {
        url.splice(1, 1, langCookie);
        history.replace(url.join("/"));
      } else {
        //console.log("404");
        history.replace("/en");
      }
    } else {
      //console.log("yes language code");
      setCheck(true);
      // if user visits a different url for a different language update their lang setting

      localStorage.setItem("lang", url[1]);
    }
  }, [location.pathname]);

  //console.log(lang);basename={`/${lang}`}

  return (
    <Router>
      <ScrollToTop>
        <Route component={NavBar} />
        <Switch>
          <Route
            //path={`${langCheck ? "/:lang" : "/"}`}
            path="/:lang?"
            exact
            component={HubPage}
          />
          <Route
            exact
            path="/:lang/academy/catalogue/:slug"
            component={CourseInner}
          />
          <Route
            exact
            path="/:lang/academy/catalogue"
            component={AcademyCataloguePage}
          />
          <Route exact path="/:lang/academy" component={AcademyPage} />
          <Route exact path="/:lang/academy/*" component={NoMatch} />
          <Route
            exact
            path="/:lang/cafe/catalogue/:slug"
            component={ArticleInner}
          />
          <Route
            exact
            path="/:lang/cafe/catalogue"
            component={CafeCataloguePage}
          />
          <Route
            exact
            path="/:lang/cafe/news/catalogue/:slug"
            component={NewsInner}
          />
          <Route
            exact
            path="/:lang/cafe/news/catalogue"
            component={NewsCataloguePage}
          />
          <Route exact path="/:lang/cafe" component={CafePage} />
          <Route exact path="/:lang/about" component={AboutZeFiPage} />
          <Route exact path="/:lang/about/*" component={NoMatch} />
          <Route exact path="/:lang/cafe" component={CafePage} />
          <Route exact path="/:lang/people" component={PeoplePage} />
          <Route exact path="/:lang/about" component={AboutZeFiPage} />
          <Route exact path="/:lang/about/*" component={NoMatch} />
          <Route exact path="/:lang/*" component={NoMatch} />
          <Route exact path="/:lang/cafe/*" component={NoMatch} />
          <Route exact path="/:lang/404" component={NoMatch} />
        </Switch>
        <Route component={Footer} />
      </ScrollToTop>
    </Router>
  );
}

export default App;
